"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NRTMetricId = void 0;
var NRTMetricId;
(function (NRTMetricId) {
    NRTMetricId["ErrorsCount"] = "errorsCount";
    NRTMetricId["UsersWithErrorsCount"] = "usersWithErrorsCount";
    NRTMetricId["UsersWithErrorsRate"] = "usersWithErrorsRate";
    NRTMetricId["ViewsWithErrorsCount"] = "viewsWithErrorsCount";
    NRTMetricId["ViewsWithErrorsRate"] = "viewsWithErrorsRate";
})(NRTMetricId = exports.NRTMetricId || (exports.NRTMetricId = {}));
//# sourceMappingURL=nrt-metric.js.map